import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpHeadersHelperService } from '@core/_services/http-headers-helper.service'
import { environment } from '@env';
import { Stand } from '@conference/stands/_models/stand'
import { CurrentConferenceHelperService } from '@core/_services/current-conference-helper.service';
import { CurrentConference } from '@shared/_models/current-conference';

@Injectable({
  providedIn: 'root'
})
export class StandsService {

  private apiUrl: string = `${environment.apiUrl}`;
  private currentConference: CurrentConference = new CurrentConference();
  private endPoint: string = '/Stands';
  private headers: HttpHeaders = this.httpHeadersHelperService.getCustomHeaders();

  getAllByCurrentConferenceId() {
    this.currentConferenceHelperService.currentConference.subscribe(x => { this.currentConference = x });
    return this.http.get<Stand[]>(this.apiUrl + this.endPoint + '/GetStandsByConferenceId/' + this.currentConference.id, { headers: this.headers });
  }

  get(id: number) {
    return this.http.get<Stand>(this.apiUrl + this.endPoint + '/' + id, { headers: this.headers });
  }

  add(stand: Stand) {
    return this.http.post(this.apiUrl + this.endPoint, stand, { headers: this.headers });
  }

  edit(stand: Stand) {
    return this.http.put(this.apiUrl + this.endPoint, stand, { headers: this.headers });
  }

  delete(id: number) {
    return this.http.delete(this.apiUrl + this.endPoint + '/' + id, { headers: this.headers });
  }

  generateStandsForConference() {
    return this.http.post(this.apiUrl + this.endPoint + '/CreateStandsOnOldSystemUserDataAtConference/' + this.currentConference.id, null, { headers: this.headers });
  }

  constructor(private http: HttpClient,
    private httpHeadersHelperService: HttpHeadersHelperService,
    private currentConferenceHelperService: CurrentConferenceHelperService) { }
}
